import React from 'react';
import { Phone, CheckCircle2, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const services = ['Concrete & Pavers', 'Landscape Design', 'Outdoor Lighting', 'Patios & Walkways', 'Mulch & Planting'];
  return <div className="relative min-h-screen flex items-center pt-20 pb-16" data-id="element-122">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-123">
        <img src="https://cdn.magicpatterns.com/uploads/9NT8Bw169PrqyprixFUsot/IA1.png" alt="Beautiful landscaped driveway at sunset" className="w-full h-full object-cover object-center" data-id="element-124" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#081C15]/90 via-[#081C15]/70 to-transparent" data-id="element-125"></div>
        <div className="absolute inset-0 bg-black/30" data-id="element-126"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-127">
        <div className="max-w-3xl" data-id="element-128">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white mb-6" data-id="element-129">
            <MapPin size={16} className="text-[#D4A373]" data-id="element-130" />
            <span className="text-sm font-medium tracking-wide uppercase" data-id="element-131">
              Serving Northeast Ohio
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6" data-id="element-132">
            Finally — A Landscaping Company That Actually{' '}
            <span className="text-[#D4A373] italic" data-id="element-133">Shows Up</span>, Does the
            Work Right, and Leaves Your Outdoor Space Looking Like a Million
            Bucks.
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-wrap gap-3 mb-10" data-id="element-134">
            {services.map((service, index) => <div key={index} className="flex items-center gap-2 text-white/90 bg-black/20 backdrop-blur-sm px-3 py-1.5 rounded-md border border-white/10" data-id="element-135">
                <CheckCircle2 size={16} className="text-[#D4A373]" data-id="element-136" />
                <span className="text-sm md:text-base" data-id="element-137">{service}</span>
              </div>)}
            <div className="flex items-center gap-2 text-white/90 bg-black/20 backdrop-blur-sm px-3 py-1.5 rounded-md border border-white/10" data-id="element-138">
              <CheckCircle2 size={16} className="text-[#D4A373]" data-id="element-139" />
              <span className="text-sm md:text-base" data-id="element-140">And Much More</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-141">
            <motion.a href="tel:4402221065" whileHover={{
            scale: 1.04
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0 0 20px rgba(196,30,36,0.3)', '0 0 40px rgba(196,30,36,0.5)', '0 0 20px rgba(196,30,36,0.3)']
          }} transition={{
            boxShadow: {
              repeat: Infinity,
              duration: 2.5,
              ease: 'easeInOut'
            }
          }} className="relative flex flex-col items-center bg-[#C41E24] text-white rounded-2xl overflow-hidden group" data-id="element-142">
              {/* Auto-playing shine sweep */}
              <motion.span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/15 to-transparent skew-x-12 pointer-events-none" animate={{
              x: ['-150%', '150%']
            }} transition={{
              repeat: Infinity,
              duration: 3,
              ease: 'easeInOut',
              repeatDelay: 2
            }} data-id="element-143" />

              {/* Main row */}
              <span className="relative z-10 flex items-center gap-3 px-10 py-4" data-id="element-144">
                <motion.span animate={{
                rotate: [0, -12, 12, -8, 0]
              }} transition={{
                repeat: Infinity,
                duration: 0.6,
                repeatDelay: 3
              }} data-id="element-145">
                  <Phone size={22} data-id="element-146" />
                </motion.span>
                <span className="text-lg font-bold tracking-wide" data-id="element-147">
                  (440) 222-1065
                </span>
              </span>

              {/* Bottom accent bar */}
              <span className="relative z-10 w-full bg-[#a8181e] text-center py-2 text-xs font-semibold tracking-widest uppercase" data-id="element-148">
                Free Estimate — Tap to Call
              </span>
            </motion.a>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="text-white/70 mt-4 text-sm" data-id="element-149">
            (440) 222-1065 • No Obligation • Fast Response
          </motion.p>
        </div>
      </div>
    </div>;
}